import { LAYOUTS, } from '@voltmoney/types';
import { LoanRenewalScenario, WIDGET, } from '@voltmoney/schema';
import { ROUTE } from '../../../routes';
import { ACTION, } from './types';
import { enhanceLimit, getURL, goBack, goBackAction, loanRenewalExpiredRepayment, mailPop, navigation, needHelp, oldNavigation, OpenContactUS, pendingLimitAction, renewNowAction, reOpenLoanAccount } from './actions';
import SharedPropsService from '../../../SharedPropsService';
import sharedPropsService from '../../../SharedPropsService';
import { CreditApplicationType, initializeFirebase } from '../../../configs/config';
import { addMonthsToEpochTimetamp, addSuffix, getCreditData, getDateMonthYearFromEpoch, getDaysDelta, getForeClosureDetails, getManageLimitConfig, getPendingCreditRequestByCreditId, mockCurrentDate, removeUrlWithoutReload, returnDateInString, showLeinRemovalTrackingFlow } from '../../../configs/utils';
import { LENDER_ID, LOAN_RENEWAL_ALLOW_ADMIN, LOAN_RENEWAL_FLOW_SHOW, QUERY_PARAMS, TARGET_PAGES } from '../../../configs/constants';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { loanRefundAction, requestType } from "../dashboard/actions";
import moment from "moment";
export const template = (creditStatus, platform, height, creditResponse, creditAmount, sanctionedLimit, totalOutstanding, isPendingForeclosure, showNewFlow, showEnhanceLimit, pendingArray, loanExpiryDay, dueDate, actualLoanAmount, overDueAmount, loanExpiryScenario, inProgressTransaction, renewalRequestDetailsList, forceAllowPayment, isLoanContractExpired, showLeinRemovalTracking, showDecreaseLimit, showBottomNav, isLoanExpired, lenderId, showCta, showInfoSection, isPendingLoanRenewal) => {
    return {
        layout: {
            id: ROUTE.MANAGE_LIMIT,
            type: LAYOUTS.LIST,
            widgets: [
                { id: "manageLimit", type: WIDGET.MANAGE_LIMIT_PAGE }
            ]
        },
        datastore: {
            manageLimit: {
                height: height,
                creditLimit: creditAmount,
                bankData: [],
                isPendingForeclosure: isPendingForeclosure,
                backAction: {
                    type: ACTION.MENU,
                    routeId: ROUTE.MANAGE_LIMIT,
                    payload: { creditAmount: creditAmount, fundAmount: totalOutstanding },
                },
                showNavNextLoader: false,
                applyAction: {
                    type: ACTION.ENHANCE_LIMIT,
                    payload: {
                        applicationType: CreditApplicationType.CREDIT_MODIFICATION_AGAINST_SECURITIES,
                    },
                    routeId: ROUTE.MANAGE_LIMIT,
                },
                continuePress: {
                    routeId: ROUTE.MANAGE_LIMIT,
                    type: ACTION.NAVIGATION,
                    payload: {}
                },
                sanctionedAmount: sanctionedLimit,
                totalOutstanding: totalOutstanding,
                showIncreaseLimit: showEnhanceLimit,
                increaseLimitAction: {
                    type: ACTION.INCREASE_LIMIT_ACTION,
                    payload: {},
                    routeId: ROUTE.MANAGE_LIMIT,
                },
                pendingArray: pendingArray,
                pendingRequestAction: {
                    type: ACTION.PENDING_LIMIT_ACTION,
                    routeId: ROUTE.MANAGE_LIMIT,
                    payload: {}
                },
                needHelp: {
                    type: ACTION.NEED_HELP,
                    routeId: ROUTE.MANAGE_LIMIT,
                    payload: {}
                },
                isLoanContractExpired: isLoanContractExpired,
                showPledgedPortfolio: ((isLoanContractExpired === true) && loanExpiryScenario === LoanRenewalScenario.AFTER_30_DAYS) ? false : true,
                loanRenewalExpiredDashboardCardProps: {
                    loanExpiryDay: loanExpiryDay,
                    lenderId,
                    isLoanExpired,
                    dueDay: dueDate,
                    creditLimitAmount: actualLoanAmount,
                    outStandingAmount: loanExpiryScenario === LoanRenewalScenario.AFTER_30_DAYS
                        ? 0
                        : overDueAmount
                            ? overDueAmount
                            : 0,
                    scenario: loanExpiryScenario,
                    isRepaymentInProgress: inProgressTransaction,
                    showInfoSection: showInfoSection,
                    customerSupportAction: {
                        routeId: ROUTE.DASHBOARD,
                        type: ACTION.CONTACT_US,
                        payload: {}
                    },
                    renewNowAction: {
                        routeId: ROUTE.DASHBOARD,
                        type: ACTION.RENEW_NOW,
                        payload: {
                            isLoanExpired: true
                        }
                    },
                    repayAction: {
                        routeId: ROUTE.DASHBOARD,
                        type: ACTION.LOAN_EXPIRED_REPAYMENT,
                        payload: {}
                    },
                    reOpenLoanAccountAction: {
                        routeId: ROUTE.DASHBOARD,
                        type: ACTION.REOPEN_LOAN_ACCOUNT,
                        payload: {}
                    },
                    refundAction: {
                        routeId: ROUTE.DASHBOARD,
                        type: ACTION.REFUND_LOAN,
                        payload: {}
                    },
                    showCta: showCta,
                    isPendingLoanRenewal
                },
                showLeinRemovalTracking: showLeinRemovalTracking,
                showDecreaseLimit: showDecreaseLimit,
                showBottomNav: showBottomNav,
                goBackAction: {
                    type: ACTION.GO_BACK,
                    routeId: ROUTE.MANAGE_LIMIT,
                    payload: {}
                },
                platform,
            },
        },
    };
};
export const manageLimitMF = {
    onLoad: async ({ getHeight, instrumentTrack, network }, { target, cacheManageLimitConfig, cacheCreditData, cachePendingCreditRequestByCreditId, }) => {
        await initializeFirebase();
        const creditStatus = await SharedPropsService.getCreditStatus();
        const user = await SharedPropsService.getUser();
        const lenderId = user?.linkedApplications[0].lenderAccountId;
        const isLoanExpired = await SharedPropsService.getIsLoanExpired();
        let creditAmount = user.linkedCredits[0].actualLoanAmount;
        let totalOutstanding = user.linkedCredits[0].totalValueOfAssetsPledged;
        await sharedPropsService.setTotalCreditAmount(creditAmount);
        await sharedPropsService.setTotalFundAmount(totalOutstanding);
        const isPendingForeclosure = user.linkedCredits[0].creditStatus === "PENDING_CLOSURE";
        const sanctionedLimit = user.linkedCredits[0].approvedCreditAmount;
        // const requestOptions = {
        //     method: 'GET',
        //     headers: await getAppHeader(),
        // }
        await AsyncStorage.removeItem("target");
        if (target && target === TARGET_PAGES.MANAGE_LIMIT) {
            removeUrlWithoutReload(QUERY_PARAMS.TARGET);
        }
        // const manageLimitConfig = await network
        //     .get(
        //         `${api.manageLimitConfig}${user.linkedCredits[0].creditId}`, requestOptions).then(response => response.data)
        const manageLimitConfig = await getManageLimitConfig(network, { overrideCache: cacheManageLimitConfig ? false : true
        });
        const showIncreaseLimit = manageLimitConfig.increaseLimitAllowed;
        const showDecreaseLimit = manageLimitConfig.decreaseLimitAllowed;
        const showNewFlow = (manageLimitConfig.increaseLimitAllowed || manageLimitConfig.decreaseLimitAllowed);
        let creditResponse;
        let inProgressTransaction = false;
        // const pendingDisbusalResponse = await network.get(
        //     `${api.getPendingStatus}${user?.linkedCredits[0]?.creditId}`,
        //     {
        //         headers: await getAppHeader(),
        //     },
        // )
        let pendingDisbusalResponse = await getPendingCreditRequestByCreditId(network, {
            overrideCache: true
        });
        pendingDisbusalResponse.data = pendingDisbusalResponse;
        if ((pendingDisbusalResponse?.data?.collectionDetailsList &&
            pendingDisbusalResponse?.data?.collectionDetailsList.length > 0) || (pendingDisbusalResponse?.data?.disbursalDetailsList &&
            pendingDisbusalResponse?.data?.disbursalDetailsList.length > 0)) {
            inProgressTransaction = true;
        }
        const pendingArray = [];
        let isPendingLoanRenewal = false;
        if (await LOAN_RENEWAL_FLOW_SHOW()) {
            if (pendingDisbusalResponse?.data?.renewalRequestDetailsList.length > 0) {
                isPendingLoanRenewal = true;
                pendingArray.push({
                    title: "Loan renewal in progress",
                    subTitle: "We’re processing your request. Track status",
                    type: requestType.RENEWAL_REQUEST
                });
            }
        }
        const showNewLeinRemovalTracking = await showLeinRemovalTrackingFlow();
        if (!showNewLeinRemovalTracking) {
            if (pendingDisbusalResponse?.data?.enhanceLimitRequestDetailsList.length > 0) {
                pendingArray.push({
                    title: "Request for additional credit limit",
                    subTitle: "We're processing your request. Track status",
                    type: "ENHANCE"
                });
            }
        }
        // ---------------- LOAN EXPIRED FLOW ------------------ //
        let loanExpiryScenario = LoanRenewalScenario.FIRST_7_DAYS;
        let isLoanContractExpired = false;
        let overDueAmount = 0;
        let loanExpiryDay;
        let dueDate;
        let actualLoanAmount = 0;
        const forceAllowPayment = await LOAN_RENEWAL_ALLOW_ADMIN();
        if (await LOAN_RENEWAL_FLOW_SHOW()) {
            await SharedPropsService.setIsLoanExpired(false);
            const creditId = user?.linkedCredits[0]?.creditId;
            // const getCreditResponse = await network.get(
            //     `${api.getCredit}/${creditId}`,
            //     {
            //         headers: await getAppHeader(),
            //     },
            // )
            const getCreditResponse = await getCreditData(network, { overrideCache: true });
            if (getCreditResponse) {
                // const renewalDate = getCreditResponse?.data?.renewalDate;
                const renewalDate = getCreditResponse?.renewalDate;
                // const currentMoment = moment();
                const renewalDateDelta = await getDaysDelta(renewalDate);
                // actualLoanAmount = getCreditResponse?.data?.actualLoanAmount;
                actualLoanAmount = getCreditResponse?.actualLoanAmount;
                // overDueAmount = getCreditResponse?.data?.netPayable;
                overDueAmount = getCreditResponse?.netPayable;
                creditAmount = getCreditResponse?.actualLoanAmount;
                totalOutstanding = getCreditResponse?.totalValueOfAssetsPledged;
                await sharedPropsService.setTotalCreditAmount(creditAmount);
                await sharedPropsService.setTotalFundAmount(totalOutstanding);
                const config = await SharedPropsService.getFirebaseConfig();
                const loan_renewal_repayment_date_TATA = config?.loan_renewal_repayment_date_TATA;
                const loan_renewal_repayment_date_BAJAJ = config?.loan_renewal_repayment_date_BAJAJ;
                const loan_renewal_test_flag = config?.loan_renewal_test_flag;
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                //@ts-ignore
                const currentMoment = (loan_renewal_test_flag === true || loan_renewal_test_flag === 'true') ? await mockCurrentDate() : moment().startOf('day').unix() * 1000;
                const sevenDaysInMs = 6 * 24 * 60 * 60 * 1000;
                const lastRepaymentDateEpoch = renewalDate + sevenDaysInMs;
                const lastRepaymentDate = returnDateInString(lastRepaymentDateEpoch);
                const dueDay = lenderId.toLowerCase() === LENDER_ID.BAJAJ.toLowerCase()
                    ? loan_renewal_repayment_date_BAJAJ
                    : loan_renewal_repayment_date_TATA;
                dueDate = lenderId.toLowerCase() === LENDER_ID.BAJAJ.toLowerCase() ? `${dueDay}${addSuffix(dueDay)} ${moment().format('MMM')}, ${moment().format('YYYY')}` : lastRepaymentDate;
                if (currentMoment >= renewalDate ||
                    renewalDateDelta === -1) {
                    await SharedPropsService.setIsLoanExpired(true);
                    const getForeClosureData = await getForeClosureDetails(network, {
                        overrideCache: true
                    });
                    if (getForeClosureData) {
                        overDueAmount = getForeClosureData?.netPayable;
                        if (await SharedPropsService.getIsLoanExpired() && lenderId.toLowerCase() === LENDER_ID.TATA && overDueAmount === 0) {
                            loanExpiryScenario = LoanRenewalScenario.LOAN_EXPIRED_WITHOUT_OUTSTANDING;
                        }
                        else if (renewalDateDelta <= 7 && overDueAmount < 0 && lenderId.toLowerCase() === LENDER_ID.TATA) {
                            loanExpiryScenario = LoanRenewalScenario.OUTSTANDING_EXPIRED;
                        }
                        else if (renewalDateDelta <= 7) {
                            loanExpiryScenario = LoanRenewalScenario.FIRST_7_DAYS;
                        }
                        else if (
                        //@ts-ignore
                        currentMoment <= addMonthsToEpochTimetamp(renewalDate, 1) &&
                            moment(currentMoment).isSame(addMonthsToEpochTimetamp(renewalDate, 1)) === false) {
                            loanExpiryScenario = LoanRenewalScenario.FROM_7_TO_30_DAYS;
                        }
                        else {
                            loanExpiryScenario = LoanRenewalScenario.AFTER_30_DAYS;
                        }
                        isLoanContractExpired = true;
                        loanExpiryDay = renewalDate
                            ? getDateMonthYearFromEpoch(renewalDate)
                            : 'NA';
                    }
                    // --------------------------------------- //
                }
            }
        }
        // ----------------------------------------------------- //
        const showLeinRemovalTracking = await showLeinRemovalTrackingFlow();
        let showCta;
        let showInfoSection;
        if (pendingDisbusalResponse?.data?.renewalRequestDetailsList?.length > 0) {
            showCta = false;
        }
        else if (forceAllowPayment &&
            (forceAllowPayment === true || forceAllowPayment === 'true')) {
            showCta = true;
        }
        else if (loanExpiryScenario === LoanRenewalScenario.LOAN_EXPIRED_WITHOUT_OUTSTANDING) {
            showCta = false;
        }
        else if (loanExpiryScenario === LoanRenewalScenario.FROM_7_TO_30_DAYS &&
            overDueAmount === 0) {
            showCta = true;
        }
        else {
            showCta = loanExpiryScenario !== LoanRenewalScenario.FROM_7_TO_30_DAYS;
        }
        if (pendingDisbusalResponse?.data?.renewalRequestDetailsList?.length > 0 || inProgressTransaction === true ||
            //@ts-ignore
            forceAllowPayment === true || forceAllowPayment === "true") {
            showInfoSection = false;
        }
        else if (overDueAmount > 0 ||
            loanExpiryScenario === LoanRenewalScenario.OUTSTANDING_EXPIRED ||
            loanExpiryScenario === LoanRenewalScenario.LOAN_EXPIRED_WITHOUT_OUTSTANDING) {
            showInfoSection = true;
        }
        else {
            showInfoSection = false;
        }
        instrumentTrack('MANAGE_LIMIT_PAGE_VIEWED');
        const platform = await sharedPropsService.getAppPlatform();
        const showBottomNav = await SharedPropsService.getShowVoltBottomBar();
        return Promise.resolve(template(creditStatus, platform, getHeight(), creditResponse, creditAmount, sanctionedLimit, totalOutstanding, isPendingForeclosure, showNewFlow, showIncreaseLimit, pendingArray, loanExpiryDay, dueDate, actualLoanAmount, overDueAmount, loanExpiryScenario, inProgressTransaction, pendingDisbusalResponse?.data?.renewalRequestDetailsList, forceAllowPayment, isLoanContractExpired, showLeinRemovalTracking, showDecreaseLimit, showBottomNav, isLoanExpired, lenderId, showCta, showInfoSection, isPendingLoanRenewal));
    },
    actions: {
        [ACTION.EMAIL]: getURL,
        [ACTION.NAVIGATION]: navigation,
        [ACTION.OLD_NAVIGATION]: oldNavigation,
        [ACTION.MENU]: goBack,
        [ACTION.ENHANCE_LIMIT]: enhanceLimit,
        [ACTION.MARGIN_CALL]: enhanceLimit,
        [ACTION.MAIL_POPUP]: mailPop,
        [ACTION.INCREASE_LIMIT_ACTION]: enhanceLimit,
        [ACTION.PENDING_LIMIT_ACTION]: pendingLimitAction,
        [ACTION.NEED_HELP]: needHelp,
        [ACTION.RENEW_NOW]: renewNowAction,
        [ACTION.LOAN_EXPIRED_REPAYMENT]: loanRenewalExpiredRepayment,
        [ACTION.REOPEN_LOAN_ACCOUNT]: reOpenLoanAccount,
        [ACTION.CONTACT_US]: OpenContactUS,
        [ACTION.GO_BACK]: goBackAction,
        [ACTION.REFUND_LOAN]: loanRefundAction
    },
};
